import axios from 'axios';

export async function jwtAuth(username = null, password = null) {
    let refreshToken = localStorage.getItem('refreshToken');

    if (refreshToken) {
        let authOk = await axios.post('/api/token/refresh/', {refresh: refreshToken}).then(response => {
            console.log('Refreshed token');
            axios.defaults.headers.Authorization = `Bearer ${response.data.access}`;
            return true;
        }).catch(() => {
            return false;
        });
        if (authOk) return true;
    }

    return await axios.post('/api/token/', {
        username: username,
        password: password
    }).then(response => {
        console.log('Got new token');
        localStorage.setItem('refreshToken', response.data.refresh);
        axios.defaults.headers.Authorization = `Bearer ${response.data.access}`;
        return true;
    }).catch(error => {
        return false;
    });
}

let language = {
    dayNames: [
        'søndager', 'mandager', 'tirsdager', 'onsdager',
        'torsdager', 'fredager', 'lørdager'
    ],
    monthNames: [
        'januar', 'februar', 'mars', 'april', 'mai',
        'juni', 'juli', 'august', 'september', 'oktober',
        'november', 'desember'
    ],
};
let languageTokens = {
    'every': 'hver',
    'until': 'frem til',
    'day': 'dag',
    'days': 'dager',
    'week': 'uke',
    'weeks': 'uker',
    'year': 'år',
    'on': 'på',
    'at': 'ca. klokken',
    'and': 'og',
    'in': 'i',
    'times': 'ganger',
    'for': 'inntil',
    '(~ approximate)': '(ca.)'
};

export function rruleToText(rrule) {
    let text = rrule.toText(id => {
        return languageTokens[id] || id;
    }, language);

    text = text.replace('hver dag på ', 'på ');

    return text;
}